const deleteServiceOrderUsecase = (repository) => async (id) => {
    return await repository(id);
}

export default deleteServiceOrderUsecase